module.exports = __webpack_public_path__ + "img/loading.bfd34e4f.svg";